// import React, {useState, useEffect} from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {customerSlice, setUserParams} from '../../../features/customer/customerSlice';
// import { useNavigate } from "react-router-dom";
// import '../customerForm/CustomerForm.css';
// import { setComplaintType } from "../../../features/customer/customerSlice";
// import { IS_INTERNAL_APP } from "../../../api/ApiSettings";
// import wykrz from '../../../img/wykrz.svg';
// import { Dialog } from "../../common/dialog/Dialog";
// import { FooterButtons } from "../../common/buttons/FooterButtons";

// const CustomerForm = ({complaintType}) => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const [currentPage, setCurrentPage] = useState(window.location.pathname);
//     const customerValues = useSelector(state=>state.customer);
//     const [isDialogOpen, setIsDialogOpen] = useState(false);


//     const handleOpenDialog = () =>{
//         setIsDialogOpen(true);
//     };

//     const handleCloseDialog = () =>{
//         setIsDialogOpen(false);
//     };
//     useEffect(() => {
//         function handlePageChange() {
//             setCurrentPage(window.location.pathname);
//         }
//         window.addEventListener("popstate", handlePageChange);
//         return () => {
//             window.removeEventListener("popstate", handlePageChange);
//         };
//     }, [currentPage]);
//     //states
//     const [errors, setErrors] = useState({
//         name:false,
//         email:false,
//         phone: false,
//         street: false,
//         buildingNumber:false,
//         flatNumber: false,
//         postalCode:false,
//         city: false
//     });
//     const [nameValue, setNameValue] = useState("");
//     const [emailValue, setEmailValue] = useState("");
//     const [phoneValue, setPhoneValue] = useState("");
//     const [streetValue, setStreetValue] = useState("");
//     const [buildingNumberValue, setBuildingNumberValue] = useState("");
//     const [flatNumber, setFlatNumber] = useState("");
//     const [postalCodeValue,setPostalCodeValue] = useState("");
//     const [cityValue, setCityValue] = useState("");
//     //selector
//     const userData = useSelector(state => state.customer);

//     //regex
//     const emailRegex = /^\S+@\S+\.\S+$/;
//     const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
//     const postaCodeRegex = /^[0-9]{2}-[0-9]{3}$/;
//     //validate
//     const validate = (name, value) => {
//         switch (name) {
//             case "name":
//                 return value !== "";
//             case "email":
//                 return emailRegex.test(value);
//             case "phone":
//                 return phoneRegex.test(value);
//             case "street":
//                 return value !== "";
//             case "buildingNumber":
//                 return value !== "";
//             case "postalCode":
//                 return postaCodeRegex.test(value);
//             case "city":
//                 return value !== "";
//             default:
//                 return true;
//         }
//     }
//     //click on button next
//     const handleNextClick = (option) =>{
//         const input = document.querySelectorAll('input');
//         let formValid = true;
//         let userData = {};
        
//         input.forEach(input => {
//             if(input.name === 'flatNumber'){
//                 userData[input.name] = input.value;
//             }else if(!input.value === 'name'){
//                 formValid = false;
//             }else if(!validate(input.name, input.value)) {
//                 formValid = false;
//             }
//             else
//             {
//                 userData[input.name] = input.value;
//             }
//         });
//         if(!formValid && IS_INTERNAL_APP=== false){
//                 setErrors({
//                     ...errors,
//                     name: !validate("name", nameValue),
//                     email: !validate("email", emailValue),
//                     phone: !validate("phone", phoneValue),
//                     street: !validate("street", streetValue),
//                     buildingNumber: !validate("buildingNumber", buildingNumberValue),
//                     postalCode: !validate("postalCode", postalCodeValue),
//                     city: !validate("city", cityValue),
//                 });
//                 return;
//             }
//             setErrors({
//                 name: false,
//                 email: false,
//                     phone: false,
//                     street: false,
//                     buildingNumber: false,
//                     postalCode: false,
//                     city: false
//                 });
//                 dispatch(customerSlice.actions.setUserParams(userData))
//                 if(formValid === true && IS_INTERNAL_APP === false){
//                     setCurrentPage('registration');
//                     navigate('/registration');
//                 }else{
//                     setCurrentPage('registration');
//                     navigate('/registration');  
//                 }
//                 //aktualizacja stanu w CustomerSlice i przekazanie danych z ComplaintSlice (complaintType)
//                 dispatch(setComplaintType(complaintType));
//             }
//         const handleChange = (event) => {
//                 const { name, value } = event.target;
                
//         switch (name) {
//             case "name":
//                 setNameValue(value);
//                 break;
//             case "email":
//                 setEmailValue(value);
//                 break;
//             case "phone":
//                 setPhoneValue(value);
//                 break;
//             case "street":
//                 setStreetValue(value);
//                 break;
//             case "buildingNumber":
//                 setBuildingNumberValue(value);
//                 break;
//             case "flatNumber":
//                 setFlatNumber(value);
//                 break;
//             case "postalCode":
//                 setPostalCodeValue(value);
//                 break;
//             case "city":
//                 setCityValue(value);
//                 break;
//             default:
//                 break;
//             }
       
//             setErrors({
//                 ...errors,
//                 [name]: !validate(name, value)
//         });
//         }

//         const handleBackClick = () =>{
//             setCurrentPage('customers');
//             navigate('/customers');  
//         }

//         return (
//     <div>
//         <div className="customer-form-container">
//         <form>
//             <div className="text-field">
//             <label style={errors.name ? {color: "red"}: {}}>Imię i nazwisko</label>
//                 <input type="text" name="name" className="frame-3" value={nameValue || customerValues.name} onChange={handleChange} style={errors.name ? {borderColor: "red"}: {}} />
//                 {errors.name && <p className="error">Pole obowiązkowe</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.email ? {color: "red"}: {}}>E-mail</label>
//                 <input type="email" name="email" className="frame-3"  value={emailValue || customerValues.email} onChange={handleChange} style={errors.email ? {borderColor: "red"}: {}}/>
//                 {errors.email && <p className = "error">Podany adres e-mail jest nieprawidłowy</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.phone ? {color: "red"}: {}}>Telefon</label>
//                 <input type="tel" name="phone" className="frame-3" value={phoneValue || customerValues.phone} onChange={handleChange} style={errors.phone ? {borderColor: "red"}: {}}/>
//                 {errors.phone && <p className="error">Podany numer telefonu jest niepoprawny</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.street ? {color: "red"}: {}}>Ulica</label>
//                 <input type="text" name="street" className="frame-3"  style={errors.street ? {borderColor: "red"}: {}} value={streetValue || customerValues.street} onChange={handleChange}/>
//                 {errors.street && <p className = "error">Pole obowiązkowe</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.buildingNumber ? {color: "red"}: {}}>Nr domu</label>
//                 <input type='text' name="buildingNumber" className="frame-3" value={buildingNumberValue || customerValues.buildingNumber} onChange={handleChange} style={errors.buildingNumber ? {borderColor: "red", width:"248px"}: {width:"248px"}}/>
//                 {errors.buildingNumber && <p className = "error">Pole obowiązkowe</p>}
//             </div>
//                 <br/>
//             <div className="text-field">      
//            <label className="frame-584">Nr lokalu <p className="optional">opcjonalnie</p></label>
//                 <input type='text' name="flatNumber" className="frame-3" value={flatNumber || customerValues.flatNumber} onChange={handleChange} style={{width:"248px"}}/>
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.postalCode ? {color: "red"}: {}}>Kod pocztowy</label>
//                 <input type="text" name="postalCode" className="frame-3"  value={postalCodeValue || customerValues.postalCode} onChange={handleChange} style={errors.postalCode ? {borderColor: "red"}: {}}/>
//                 {errors.postalCode && <p className="error">Podany kod pocztowy jest niepoprawny</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label style={errors.city ? {color: "red"}: {}}>Miejscowość</label>
//                 <input type="text" name="city" className="frame-3"  style={errors.city ? {borderColor: "red"}: {}} onChange={handleChange} value={cityValue || customerValues.city}/>
//                 {errors.city && <p className = "error">Pole obowiązkowe</p>}
//             </div>
//                 <br/>
//             <div className="text-field">
//             <label>Kraj</label>
//             <select style={{color:"#D5D5D5",fontWeight:"normal"}} className="frame-3" >
//                 <option value="" name="country">Polska</option>
//             </select>
//             </div>
//         </form>
//             <div className='information-text-container'>
//                 <img src={wykrz} className='information-img'/>
//                 <p className='information-text'>Dane zawarte w formularzu są jednocześnie adresem<br/>miejsca odbioru zgłaszanego produktu.</p>
//             </div>
//             <div>
//             <button onClick={handleOpenDialog} className="rodo-btn">Wyświetl klauzulę RODO</button>
//             <Dialog isOpen={isDialogOpen} onClose={handleCloseDialog}>
//                 <p style={{fontFamily:'Montserrat'}}><h4>Klauzula informacyjna RODO</h4><br/>
//                    <strong>Zgodnie z art. 13 ust. 1 i ust. 2 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r. informuję, iż:</strong><br/>
//                    <ol>
//                    1. administratorem Pani/Pana danych osobowych jest PRO sp. z o.o. z siedzibą w Bielsko-Biała ul. Strażacka 76;<br/>
//                    2. kontakt z powołanym przez PRO sp. z o.o. inspektorem ochrony danych pod adresem e-mail: iod@poziomnica.pl;<br/>
//                    3. Pani/Pana dane osobowe przetwarzane będą w celu:<br/>
//                    <ul>
//                    <li>w celach wynikających z prawnie uzasadnionych interesów realizowanych przez PRO sp. z o.o. jako administratora danych (podstawa prawna art. 6 ust. 1 lit. f RODO);</li>
//                    <li>w celu wykonywania umów zawieranych przez PRO sp. z o.o. z klientami (podstawa prawna art. 6 ust. 1 lit. b RODO);</li>
//                    <li>w celu prowadzenia rekrutacji osób zainteresowanych pracą PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. a RODO).</li>
//                    </ul>
//                    4. Przetwarzamy dane osobowe również w zakresie wypełnienia obowiązków prawnych ciążących na PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. c RODO).Pani/Pana dane osobowe będą przechowywane do momentu wycofania zgody/zakończenia współpracy;<br/>
//                    5. posiada Pani/Pan prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo wniesienia sprzeciwu, prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania , którego dokonano na podstawie zgody przed jej cofnięciem;<br/>
//                    6. ma Pani/Pan prawo wniesienia skargi do PUODO gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r.<br/>
//                     </ol>
//                 </p>
//             </Dialog>
//             </div>
//         </div>
//         <div className="btn-frame">
//                <button className="prev-btn" onClick={handleBackClick}><p className="navigation-button-back-text">Wróć</p></button>
//                <button className="next-btn" onClick={handleNextClick}><p className="navigation-button-next-text">Dalej</p></button>
//         </div>
//     </div>
//   )
// }
//  export default CustomerForm;





 import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { customerSlice, setUserParams, setComplaintType } from "../../../features/customer/customerSlice";
import { useNavigate } from "react-router-dom";
import { IS_INTERNAL_APP } from "../../../api/ApiSettings";
import wykrz from "../../../img/wykrz.svg";
import { Dialog } from "../../common/dialog/Dialog";
import { NextAndBackButtons } from "../../common/buttons/nextAndBackButtons/NextAndBackButtons";

const CustomerForm = ({ complaintType }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customerValues = useSelector(state => state.customer);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({
    name: "", email: "", phone: "",
    street: "", buildingNumber: "", flatNumber: "",
    postalCode: "", city: ""
  });

  const fieldLabels = {
    name: "Imię i nazwisko",
    email: "E-mail",
    phone: "Telefon",
    street: "Ulica",
    buildingNumber: "Nr domu",
    flatNumber: "Nr lokalu (opcjonalnie)",
    postalCode: "Kod pocztowy",
    city: "Miejscowość"
  };

  const emailRegex = /^\S+@\S+\.\S+$/;
  const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
  const postalCodeRegex = /^[0-9]{2}-[0-9]{3}$/;

  const validate = (name, value) => {
    switch (name) {
      case "name": case "street": case "buildingNumber": case "city":
        return value.trim() !== "";
      case "email":
        return emailRegex.test(value);
      case "phone":
        return phoneRegex.test(value);
      case "postalCode":
        return postalCodeRegex.test(value);
      default:
        return true;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({
      ...prev,
      [name]: !validate(name, value)
    }));
  };

  const handleNextClick = () => {
    let formValid = true;
    const newErrors = {};

    Object.keys(formValues).forEach(key => {
      if (key !== "flatNumber" && !validate(key, formValues[key])) {
        formValid = false;
        newErrors[key] = true;
      } else {
        newErrors[key] = false;
      }
    });

    setErrors(newErrors);

    if (!formValid && !IS_INTERNAL_APP) return;

    dispatch(customerSlice.actions.setUserParams(formValues));
    dispatch(setComplaintType(complaintType));
    navigate("/registration");
  };

  const handleBackClick = () => navigate("/customers");

  return (
    <div className="view-container">
      <form>
        {Object.keys(formValues).map(field => (
          <div key={field}>
            <label style={errors[field] ? { color: "red" } : {}}>
              {fieldLabels[field]}
            </label>
            <input
              type={field === "email" ? "email" : field === "phone" ? "tel" : "text"}
              name={field}
              className="input-field"
              value={formValues[field] || customerValues[field] || ""}
              onChange={handleChange}
              style={errors[field] ? { borderColor: "red" } : {}}
            />
            {errors[field] && (
              <p className="error">
                {field === "email" ? "Niepoprawny adres e-mail" :
                 field === "phone" ? "Niepoprawny numer telefonu" :
                 field === "postalCode" ? "Niepoprawny kod pocztowy" :
                 "Pole nie może być puste"}
              </p>
            )}
          </div>
        ))}
      </form>

      <div className="information-text-container">
        <img src={wykrz} className="information-img" alt="info" />
        <p className="information-text">
          Dane zawarte w formularzu są adresem miejsca odbioru zgłaszanego produktu.
        </p>
      </div>
 
      <button onClick={() => setIsDialogOpen(true)} className="btn btn-primary">
        Wyświetl klauzulę RODO
      </button>

      <Dialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <div style={{ fontFamily: "Montserrat", padding: "10px" }}>
          <h4>Klauzula informacyjna RODO</h4>
          <p><strong>Zgodnie z art. 13 ust. 1 i 2 RODO informuję, że:</strong></p>
          <ol>
            <li>Administratorem danych jest PRO sp. z o.o. z siedzibą w Bielsko-Biała ul. Strażacka 76.</li>
            <li>Kontakt z Inspektorem Ochrony Danych: iod@poziomnica.pl</li>
            <li>Dane przetwarzane będą w celu:
              <ul>
                <li>w celach prawnie uzasadnionych interesów PRO sp. z o.o. (art. 6 ust. 1 lit. f RODO)</li>
                <li>wykonywania umów z klientami (art. 6 ust. 1 lit. b RODO)</li>
                <li>prowadzenia rekrutacji (art. 6 ust. 1 lit. a RODO)</li>
              </ul>
            </li>
            <li>Dane będą przetwarzane również w celu wypełnienia obowiązków prawnych (art. 6 ust. 1 lit. c RODO).</li>
            <li>Posiada Pani/Pan prawo dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu, cofnięcia zgody.</li>
            <li>Możliwość wniesienia skargi do PUODO.</li>
          </ol>
        </div>
      </Dialog>

      <NextAndBackButtons onBack={handleBackClick} onNext={handleNextClick} />
    </div>
  );
};

export default CustomerForm;
